<ng-container *transloco="let t">
  <ng-container *ngIf="step$ | async as step">

    <ng-template #buttonTmpl>
      <button mat-flat-button type="button" color="accent" (click)="loadValues(step.id)">
        <mat-icon>visibility</mat-icon>
        {{t('external-ws-report.loadValues')}}
      </button>
    </ng-template>

    <ng-container *ngIf="showValues$ | async; else buttonTmpl">
      <ng-container *ngIf="valuesList$ | async as list">
        <ng-container *ngIf="list.length > 0; then valuesTmpl; else emptyTmpl"></ng-container>

        <ng-template #valuesTmpl>
          <div class="row">
            <div class="col-4">
              <div class="row px-3" *ngIf="commonInputData$ | async as cid">
                <label class="mr-1">{{t('external-ws-report.cycleCounter')}}</label><strong
                  class="mr-2">{{cid.cycleCounter}}</strong>
                <label class="mr-1">{{t('external-ws-report.programCode')}}</label><strong
                  class="mr-2">{{cid.programCode}}</strong>
              </div>
              <div class="row">
                <div class="col-12">
                  <label>{{t('external-ws-report.valuesTitle')}}</label>
                </div>
              </div>
              <div class="row" *ngFor="let v of list">
                <div class="col-12">
                  <span class="mr-2">[{{v.timestamp | date:'HH:mm:ss.SSS'}}]:</span>
                  <span class="mr-2 text-capitalize">[{{v.label}}]:</span>
                  <strong>{{v.value}}</strong>
                </div>
              </div>
            </div>
            <div class="col-8">
              <canvas baseChart [datasets]="(chartDatasets$ | async) || []" [labels]="(chartLabels$ | async) || []"
                [chartType]="'line'" [legend]="false" [colors]="lineChartColors">
              </canvas>
            </div>
          </div>
        </ng-template>

        <ng-template #emptyTmpl>
          <div class="row">
            <div class="col-12">
              <span>{{t('external-ws-report.noValues')}}</span>
            </div>
          </div>
        </ng-template>

      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
